import React, { useState, useRef, useEffect } from 'react';
import ReactToPrint from 'react-to-print';
// import { toWords } from 'number-to-words';
// @mui
import { GlobalStyles, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/system';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
// Iconify
import Iconify from 'src/components/iconify';
// types
import { Check } from 'src/types/checks';
import { numberToFrenchText } from 'src/utils/format/number-to-test';

interface BankConfig {
  width: string;
  height: string;
  backgroundImage: string;
  prixStyle: object;
  prixLettreStyle: object;
  benificierStyle: object;
  lieuStyle: object;
  dateStyle: object;
  typeStyle: object;
  dueDateStyle?: object;
  causeStyle?: object;
}
// Function to convert number to French words
// function NumberToFrenchWords(nombre: number): string {
//   let output = '';
//   try {
//     if (Number.isNaN(nombre)) {
//       return "";
//     }
//     output = toWords(nombre);
//     return output.charAt(0).toUpperCase() + output.slice(1);
//   } catch (error) {
//     console.log(error);
//   }
//   return output;
// }

interface CheckDialogProps {
  open: boolean;
  onClose: () => void;
  row: Check;
}

// Define configurations for each bank
const bankConfigs: Record<string, BankConfig> = {
  "2": {  // attijari
    width: '17.6cm',
    height: '8cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-2.jpg)',
    prixStyle: { top: '0.75cm', left: '8.9cm', fontSize: '18px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.5cm', left: '3.7cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '390px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '2.7cm', left: '4.1cm', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.5cm', left: '4.1cm', fontSize: '16px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.5cm', left: '9.0cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "7": {  // cih
    width: '17.5cm',
    height: '7.9cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-7.jpeg)',
    prixStyle: { top: '0.0cm', left: '9.6cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.2cm', left: '3.7cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '390px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '2.4cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.2cm', left: '5.8cm', fontSize: '15px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.2cm', left: '9.9cm', fontSize: '15px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "8": {  // bank of africa
    width: '17.2cm',
    height: '7.7cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-8.jpeg)',
    prixStyle: { top: '0.4cm', left: '8.7cm', fontSize: '18px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.5cm', left: '3.5cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '386px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '2.7cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.2cm', left: '4.8cm', fontSize: '15px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.2cm', left: '9.5cm', fontSize: '16px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "9": {  // bp
    width: '17.3cm',
    height: '7.9cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-9.jpeg)',
    prixStyle: { top: '0.1cm', left: '9.5cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.8cm', left: '3.8cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '390px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '2.9cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.5cm', left: '3.9cm', fontSize: '15px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.5cm', left: '9.0cm', fontSize: '16px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },

  "10": {  // barid
    width: '17.3cm',
    height: '7.9cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-10.jpeg)',
    prixStyle: { top: '0.6cm', left: '9.4cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.8cm', left: '3.9cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '390px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '3cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.6cm', left: '5.9cm', fontSize: '16px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.6cm', left: '9.5cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "11": {  // agricoel
    width: '17.5cm',
    height: '8cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-11.jpeg)',
    prixStyle: { top: '0.4cm', left: '10.2cm', fontSize: '16px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.6cm', left: '4.3cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '390px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '2.7cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.2cm', left: '4.5cm', fontSize: '16px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.2cm', left: '9.5cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "15": {  // sg
    width: '17.2cm',
    height: '8.1cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-15.jpeg)',
    prixStyle: { top: '0.4cm', left: '9.3cm', fontSize: '18px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.3cm', left: '4cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '390px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '2.6cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.2cm', left: '3.6cm', fontSize: '16px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.2cm', left: '8.6cm', fontSize: '17px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "23": {  // credit de maroc
    width: '17.4cm',
    height: '8cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-23.jpeg)',
    prixStyle: { top: '0.2cm', left: '9.8cm', fontSize: '18px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    prixLettreStyle: { top: '1.8cm', left: '4.6cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '3  cm', left: '4.1cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '3.7cm', left: '7.2cm', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    dateStyle: { top: '3.7cm', left: '10.3cm', fontSize: '14px', fontWeight: 'bolder', width: '380px', lineHeight: '1.5', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // do not change this one
  },
  "24": {  // trisore de maroc
    width: '17.4cm',
    height: '8.0cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-tgur.jpeg)',
    prixStyle: { top: '0.7cm', left: '12.6cm', width: '132px', fontSize: '18px', fontWeight: 'bolder', textAlign: 'center' },
    prixLettreStyle: { top: '1.9cm', left: '3.9cm', width: '380px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', lineHeight: '1.5', textAlign: 'center' },
    benificierStyle: { top: '3.3cm', left: '4.1cm', width: '380px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', lineHeight: '1.5', textAlign: 'center' },
    lieuStyle: { top: '4.0cm', left: '6.9cm', width: '170px', fontSize: '16px', fontWeight: 'bolder', textTransform: 'uppercase', display: 'block', textAlign: 'center' },
    dateStyle: { top: '4.0cm', left: '12.0cm', width: '170px', fontSize: '17px', fontWeight: 'bolder', textAlign: 'center' },
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // unchanged, as per usual
  },
  "25": {  // lcn attijari
    width: '20cm',
    height: '10.3cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-wafa3.jpeg)',
    prixStyle: { top: '1.4cm', left: '15.25cm', width: '130px', fontSize: '17px', fontWeight: 'bolder' },
    prixLettreStyle: { top: '3.5cm', left: '14cm', width: '205px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', lineHeight: '1.35' },
    benificierStyle: { top: '2.5cm', left: '7.6cm', width: '400px', fontSize: '17px', fontWeight: 'bolder', textTransform: 'uppercase' },
    lieuStyle: { top: '3.4cm', left: '7.3cm', width: '130px', fontSize: '17px', fontWeight: 'bolder', textTransform: 'uppercase', display: 'block', textAlign: 'left' },
    dateStyle: { top: '3.4cm', left: '10.9cm', width: '110px', fontSize: '17px', fontWeight: 'bolder' },
    dueDateStyle: { top: '0.48cm', left: '15.5cm', width: '110px', fontSize: '16px', fontWeight: 'bolder', display: 'block' }, // Showduedate
    causeStyle: { top: '4.2cm', left: '6.8cm', width: '270px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase' }, // Showcause
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // unchanged
  },
  "26": {  // lcn sg
    width: '20.1cm',
    height: '10.5cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-soce.jpeg)',
    prixStyle: { top: '1.7cm', left: '15.7cm', width: '130px', fontSize: '16px', fontWeight: 'bolder' },
    prixLettreStyle: { top: '3.6cm', left: '15.2cm', width: '170px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', lineHeight: '1.2' },
    benificierStyle: { top: '2.4cm', left: '7.6cm', width: '400px', fontSize: '17px', fontWeight: 'bolder', textTransform: 'uppercase' },
    lieuStyle: { top: '3.4cm', left: '8cm', width: '130px', fontSize: '16px', fontWeight: 'bolder', textTransform: 'uppercase', display: 'block', textAlign: 'left' },
    dateStyle: { top: '3.4cm', left: '11.3cm', width: '110px', fontSize: '16px', fontWeight: 'bolder' },
    dueDateStyle: { top: '0.7cm', left: '15.8cm', width: '110px', fontSize: '16px', fontWeight: 'bolder', display: 'block' }, // Showduedate
    causeStyle: { top: '4.3cm', left: '7.2cm', width: '270px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase' }, // Showcause
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // unchanged
  },
  "27": {  // lcn bq
    width: '20.7cm',
    height: '10.7cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-pop2.jpeg)',
    prixStyle: { top: '1.7cm', left: '16.2cm', width: '130px', fontSize: '16px', fontWeight: 'bolder' },
    prixLettreStyle: { top: '3.9cm', left: '15.1cm', width: '195px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', lineHeight: '1.2' },
    benificierStyle: { top: '3cm', left: '7.6cm', width: '400px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase' },
    lieuStyle: { top: '3.9cm', left: '8.6cm', width: '130px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', display: 'block', textAlign: 'left' },
    dateStyle: { top: '3.9cm', left: '11.9cm', width: '110px', fontSize: '15px', fontWeight: 'bolder' },
    dueDateStyle: { top: '0.6cm', left: '16.5cm', width: '110px', fontSize: '16px', fontWeight: 'bolder', display: 'block' }, // Showduedate
    causeStyle: { top: '4.5cm', left: '7.9cm', width: '270px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase' }, // Showcause
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // unchanged
  },
  "28": {  // lcn cam
    width: '19.5cm',
    height: '10.0cm',
    backgroundImage: 'url(/print-cheques/cheque/mr-cam2.jpeg)',
    prixStyle: { top: '1.25cm', left: '15.2cm', width: '130px', fontSize: '14px', fontWeight: 'bolder' },
    prixLettreStyle: { top: '3.2cm', left: '14.5cm', width: '170px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', lineHeight: '1.2' },
    benificierStyle: { top: '2.15cm', left: '7.5cm', width: '430px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase' },
    lieuStyle: { top: '3.1cm', left: '7.8cm', width: '140px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase', display: 'block', textAlign: 'left' },
    dateStyle: { top: '3.1cm', left: '10.8cm', width: '110px', fontSize: '14px', fontWeight: 'bolder' },
    dueDateStyle: { top: '0.3cm', left: '15.5cm', width: '110px', fontSize: '16px', fontWeight: 'bolder', display: 'block' }, // Showduedate
    causeStyle: { top: '4cm', left: '7.0cm', width: '270px', fontSize: '14px', fontWeight: 'bolder', textTransform: 'uppercase' }, // Showcause
    typeStyle: { top: '0cm', left: '0cm', width: '100px' } // unchanged
  },

};

// ----------------------------------------------------------------------

export default function PrintCheck({ open, onClose, row }: CheckDialogProps) {
  const [amount, setAmount] = useState(row.amount);
  const [beneficiary, setBeneficiary] = useState(row.beneficiere);
  const [location, setLocation] = useState(row.agence);
  const [date, setDate] = useState(row.taken_date);
  const [dueDate, setDueDate] = useState<string | null>(row.due_date);
  const [cause, setCause] = useState<string | null>(row.cause);
  const [type, setType] = useState('/print-cheques/img/NONE.png'); let bank_ii = '';
  if (row.type === 1) {
    bank_ii = row.bank_id.toString();
  } else if (row.bank_id === 15) {
    bank_ii = '26';
  } else if (row.bank_id === 9) {
    bank_ii = '27';
  } else if (row.bank_id === 11) {
    bank_ii = '28';
  } else {
    bank_ii = '25';
  }

  const [selectedBank, setSelectedBank] = useState<string>(bank_ii);
  const [bankConfig, setBankConfig] = useState(bankConfigs[selectedBank]);
  useEffect(
    () => {
      if (bankConfigs[selectedBank])
        setBankConfig(bankConfigs[selectedBank]);
      else {
        setBankConfig(bankConfigs['2']);
      }
    }, [selectedBank]
  );
  // Ref to access the CheckPreview component
  const checkPreviewRef = useRef<HTMLDivElement>(null);

  const CheckPreview = styled('div')<{ width: string; height: string; }>(({ width, height }) => ({
    width,
    height,
    backgroundColor: 'none',
    backgroundSize: 'cover',
    position: 'relative',
    margin: '0px',
    marginTop: '0px',
    borderRadius: '4px'
  }));

  return (
    <>
      <GlobalStyles
        styles={{
          '@media print': {
            '@page': {
              size: 'A4 landscape',
              margin: 0,
            },
            body: {
              margin: 0,
              padding: 0,
              lineHeight: 1.5,
            },
            '#checkPreview': {
              position: 'absolute',
              top: '50%',
              right: '0',
              transform: 'translateY(-50%)',
              margin: 0,
              padding: 0,
              direction: 'ltr !important',
              unicodeBidi: 'embed', // Ensures LTR text rendering
            },
            '#checkPreview *': {
              direction: 'ltr !important',
              unicodeBidi: 'embed', // Fixes possible browser inconsistencies
            },
          },
        }}
      />

      <Dialog open={open} disableEscapeKeyDown onClose={(_, reason) => reason !== 'backdropClick' && onClose()} maxWidth="lg" fullWidth>
        <DialogTitle>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Iconify icon="eva:printer-fill" sx={{ fontSize: 40, mr: 1 }} />
            Print Check
          </div>
        </DialogTitle>

        <DialogContent>
          <div style={{ flexWrap: 'wrap', paddingTop: '8px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <FormControl fullWidth>
                  <InputLabel id="bank-select-label">Bank</InputLabel>
                  <Select
                    labelId="bank-select-label"
                    id="bank-select"
                    value={selectedBank}
                    label="Bank"
                    onChange={(e) => setSelectedBank(e.target.value)}
                  >
                    <MenuItem value={2}>ATTIJARIWAFA BANK</MenuItem>
                    <MenuItem value={7}>CIH BANK</MenuItem>
                    <MenuItem value={8}>BANK OF AFRICA</MenuItem>
                    <MenuItem value={9}>BANQUE POPULAIRE</MenuItem>
                    <MenuItem value={10}>AL BARID BANK</MenuItem>
                    <MenuItem value={11}>CREDIT AGRICOLE</MenuItem>
                    <MenuItem value={15}>SOCIETE GENERALE</MenuItem>
                    <MenuItem value={23}>CREDIT DU MAROC</MenuItem>
                    <MenuItem value={24}>TRESORERIE GENERALE DU ROYAUME</MenuItem>
                    <MenuItem value={25}>ATTIJARIWAFA BANK - LCN</MenuItem>
                    <MenuItem value={26}>SOCIETE GENERALE - LCN</MenuItem>
                    <MenuItem value={27}>BANQUE POPULAIRE - LCN</MenuItem>
                    <MenuItem value={28}>CREDIT AGRICOLE - LCN</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  fullWidth
                  label="The Amount"
                  value={amount}
                  onChange={(e) => setAmount(parseFloat(e.target.value))}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  fullWidth
                  label="Beneficiary"
                  value={beneficiary}
                  onChange={(e) => setBeneficiary(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  fullWidth
                  label="Location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  fullWidth
                  label="La date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </Grid>
              {(row.type === 2) && (<>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <TextField
                    fullWidth
                    label="Due date"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <TextField
                    fullWidth
                    label="The cause"
                    value={cause}
                    onChange={(e) => setCause(e.target.value)}
                  />
                </Grid>
              </>)}

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <FormControl fullWidth>
                  <InputLabel id="bank-select-label">Type</InputLabel>
                  <Select
                    labelId="type-select-label"
                    id="bank-type"
                    value={type}
                    label="Type"
                    onChange={(e) => setType(e.target.value)}
                  >
                    <MenuItem value="/print-cheques/img/NONE.png">Normal check</MenuItem>
                    <MenuItem value="/print-cheques/img/barre.png">Crossed check</MenuItem>
                    <MenuItem value="/print-cheques/img/NE.png">Non Endossable</MenuItem>
                    <MenuItem value="/print-cheques/img/BARRENE.png">Non Endossable + Crossed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '16px',
              height: '100%',
              direction: 'ltr',
            }}
          >
            <div
              style={{
                width: bankConfig.width,
                height: bankConfig.height,
                backgroundImage: bankConfig.backgroundImage,
                backgroundSize: 'cover',
                position: 'relative',
                direction: 'ltr',
              }}
            >
              <CheckPreview
                ref={checkPreviewRef}
                width={bankConfig.width}
                height={bankConfig.height}
                id="checkPreview"
                style={{ position: 'relative' }}
              >
                <div style={{ ...bankConfig.typeStyle, position: 'absolute', color: 'black' }}>
                  <img src={type} alt="check type" width="100px" height="100px" />
                </div>
                <div style={{ ...bankConfig.prixStyle, position: 'absolute', color: 'black' }}>#{amount}#</div>
                <div style={{ ...bankConfig.prixLettreStyle, position: 'absolute', color: 'black' }}>{numberToFrenchText(amount)}</div>
                <div style={{ ...bankConfig.benificierStyle, position: 'absolute', color: 'black' }}>{beneficiary}</div>
                <div style={{ ...bankConfig.lieuStyle, position: 'absolute', color: 'black' }}>{location}</div>
                <div style={{ ...bankConfig.dateStyle, position: 'absolute', color: 'black' }}>{date}</div>
                {(row.type === 2) && (<>
                  <div style={{ ...bankConfig.dueDateStyle, position: 'absolute', color: 'black' }}>{dueDate}</div>
                  <div style={{ ...bankConfig.causeStyle, position: 'absolute', color: 'black' }}>{cause}</div>
                </>)}
              </CheckPreview>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <ReactToPrint
            trigger={() => <Button variant="contained">Print</Button>}
            content={() => checkPreviewRef.current}
          />
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
